import Vue from 'vue'
import Vuex from 'vuex'
import { db } from './db'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showMenu: false,
    showCreatePost: false,
    showLogin: false,
    showSignUp: true,
    showPopMess: false,
    popMessText: 'Hello',
    sistaPostenData: null,
    allaPosterData: [],
    top10: null,
    showLegal: false,
    showTerms: false,
    showPrivacy: false,
    showCookies: false,
    showAbout: false,
    showContact: false,
    scrollOff: false,
    showLoadMore: true,
    debaterProfiles: [],
    lastScrollPosition: 0,
    showNavbar: true,
    activePage: false,
    fetchedTitle: null,
  },
  mutations: {
    fetchPosts(state, payload) {
      //Detta är byggt så att jag endast hämtar dom poster jag behöver åt gången. För varje fetch så reggar jag sista posten i variabeln "sistaPostenData", sen sätter jag ihop en ny variabel av resultaten i "allaPosterData" och skickar den till komponenterna
      //Kollar först om sistaPosten variabeln är tom eller inte
      if (!state.sistaPostenData) {
        let first = db
          .collection("posts")
          .orderBy("timeStamp", "desc")
          .limit(10)
        first.get().then(q => {
          // Hämta sista dokumentets "timeStamp", Timestamp verkar vara ända som fungera på "startAfter"
          state.sistaPostenData = q.docs[q.docs.length - 1].data().timeStamp
          let allaPoster = []
          q.forEach(doc => {
            let uid = { id: doc.id }
            let data = doc.data()
            allaPoster.push({ ...uid, ...data });
          })
          return state.allaPosterData = [...state.allaPosterData, ...allaPoster]
        })
        .catch(err => { console.error(err) })
      } else {
      //Om "sistaPostenData" finns så hämtar jag här nästa posts som startar efter den
        let next = db
          .collection("posts")
          .orderBy("timeStamp", "desc")
          .startAfter(state.sistaPostenData)
          .limit(10)
        next.get().then(q => {
          if (q.size > 0) {
            var nyaSistaPosten = q.docs[q.docs.length - 1].data().timeStamp;
            state.sistaPostenData = nyaSistaPosten
            let allaPoster = []
            q.forEach(doc => {
              let uid = { id: doc.id }
              let data = doc.data()
              allaPoster.push({ ...uid, ...data })
            });
            state.allaPosterData = [...state.allaPosterData, ...allaPoster]
            //quick fix för att släcka Load More knappen vid < 10 resultat
            if (q.size < 10) {
              state.showLoadMore = false
            }
          } else {
            //Inga mer poster att ladda in
            //den här blir fallback om ovanstående quick fix inte funkar av någon anledning
            state.showLoadMore = false
            if (!state.showPopMess) {
              state.showPopMess = true
              state.popMessText = 'No more posts'
              setTimeout(() => {
                state.showPopMess = false
              }, 2000);
            }
          }
        })
        .catch(err => { console.error(err) })
      }

    },
    fetchTop10(state, payload) {
      const highscoreDoc = db.collection('highscore').doc('profiles')

      highscoreDoc.get().then(q => {
          const newArr = []
          Object.entries(q.data()).forEach(([key, value]) => {
              newArr.push({
                  'name': key, 
                  'votes': value.totalvotes
              });
          });
          const sortedNewArr = newArr.sort((a, b) => {
              if (a.votes > b.votes) {
                  return -1;}
              if (b.votes > a.votes) {
                  return 1;
              }
              return 0;
          })
          //Den här används i debater dropdownen när man skapar en Post
          state.debaterProfiles = sortedNewArr
          //Top10 Highscore
          const top10 = sortedNewArr.slice(0, 10)
          state.top10 = top10

      }).catch()
    },
    fetchTitle(state, payload) {  
        let arr = db
          .collection("posts")
          .doc(payload)
        arr.get().then(q => {
              const post = []
              let uid = { id: q.id }
              let data = q.data()
              post.push({ ...uid, ...data });
              return state.fetchedTitle = [...post]
          })
    },
    toggleMenu(state, payload) {
      return state.showMenu = state.showMenu != true;
    },
    toggleCreatePost(state, payload) {
      state.showCreatePost = state.showCreatePost != true;
      if (state.showLogin = true) {
        state.showLogin = false
      }
    },
    toggleLogin(state, payload) {
      state.showLogin = state.showLogin != true;
      if (state.showCreatePost = true) {
        state.showCreatePost = false
      }
    },
    showSignUp(state, payload) {
      if (payload == 'join') {
        state.showSignUp = true
      }
      if (payload == 'login') {
        state.showSignUp = false
      }
    },
    togglePopMess(state, payload) {
      // return state.showPopMess = state.showPopMess != true;
      if (!state.showPopMess) {
        state.showPopMess = true
        state.popMessText = payload
        setTimeout(() => {
          state.showPopMess = false
        }, 3000);
      }
    },
    toggleLegal(state, payload) {
      state.showLegal = state.showLegal != true;
      if (payload) {
        if (payload == 'terms') {
          state.showTerms = true
          state.showPrivacy = false
          state.showCookies = false
        }
        if (payload == 'privacy') {
          state.showPrivacy = true
          state.showTerms = false
          state.showCookies = false
        }
        if (payload == 'cookies') {
          state.showPrivacy = false
          state.showTerms = false
          state.showCookies = true
        }
      }
    },
    toggleAbout(state, payload) {
      return state.showAbout = state.showAbout != true;
    },
    toggleContact(state, payload) {
      return state.showContact = state.showContact != true;
    },
    toggleScrollOff(state, payload) {
      return state.scrollOff = state.scrollOff != true;
    },

    onScroll(state, payload) {

      window.onscroll = () => {
        // Get the current scroll position
        const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
        // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
        if (currentScrollPosition < 0) {
          return
        }
        // Find bottom of window
        let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight
        if (bottomOfWindow) {
          state.showNavbar = true 
        }
        // Stop executing this function if the difference between
        // current scroll position and last scroll position is less than some offset
        if (Math.abs(currentScrollPosition - state.lastScrollPosition) < 60) {
          return
        }
        // Here we determine whether we need to show or hide the navbar
        state.showNavbar = currentScrollPosition < state.lastScrollPosition
        // Set the current scroll position as the last scroll position
        state.lastScrollPosition = currentScrollPosition

      }
    },
    activePage(state, payload) {
      return (payload) ? state.activePage = payload : state.activePage = false
    },

  },
  actions: {
    fetchPosts: context => {
      context.commit('fetchPosts')
    },
    fetchTop10: context => {
      context.commit('fetchTop10')
    },
    onScroll: context => {
      context.commit('onScroll')
    },
    fetchTitle: (context, payload) => {
      context.commit('fetchTitle', payload)
    },

  }
})
